import { useState, useEffect, useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";

import { OrderFilter } from "./OrderFilter";
import OrderTable from "./OrderTable";

import { dateConvertor, timeConvertor } from "utils";
import { useToaster } from "hooks";
import { error as errorVariant } from "constants";
import { getCall_v2 } from "services";

import { updateQuery } from "../utils";
import { getFormattedListData } from "../makeData";
import { setorderListPathParams } from "dataStore/orderListPathParams";
import { ORDER_TRANSACTION_TYPES } from "../constant";

const AllTypeOrders = () => {
  const [ordersData, setOrdersData] = useState([]);
  const [disableReset, setDisableReset] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const triggerToaster = useToaster();

  const businessList = useSelector((state) => state.userData.businessUnits);

  const orderHeading = searchParams.get("filterType");
  const orderFilterDuration = searchParams.get("filterValue");
  const page = searchParams.get("page");

  const allowedBU = useMemo(() => {
    if (Array.isArray(businessList)) {
      return businessList?.map(({ name }) => name).join(",");
    } else {
      return "";
    }
  }, [businessList]);

  useEffect(
    () => {
      if (orderFilterDuration === null) {
        setSearchParams("filterValue=today");
      } else {
        callFilterApi();
      }
      dispatch(setorderListPathParams(searchParams.toString()));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search],
  );

  const callFilterApi = async () => {
    setIsLoading(true);
    const url = `/oms/order/orderInfo?offset=${page * 20}&limit=20`;
    let params = {
      businessUnit: allowedBU || "",
    };
    searchParams.forEach((value, key) => {
      if (key === "page") {
        return;
      }
      if (key === "filterValue" && value === "all") {
        params[key] = undefined;
      } else {
        params[key] = value || undefined;
      }
    });
    try {
      const result = await getCall_v2(url, params);
      let formattedResponse = getFormattedListData(result?.data);

      if (result?.data) {
        setOrdersData(formattedResponse);
      }
    } catch (err) {
      setOrdersData([]);
      triggerToaster(
        err?.data?.detail || "Unable to fetch orders",
        errorVariant,
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (_event, page) => {
    const updatedQuery = updateQuery(searchParams, { page });
    setSearchParams(updatedQuery);
  };

  const formatOrderDate = (dateStr) => {
    if (!dateStr) return "-";
    return `${dateConvertor(dateStr + "Z")} ${timeConvertor(dateStr + "Z")}`;
  };

  const handleExportData = async () => {
    let params = {};
    searchParams.forEach((value, key) => {
      if (key === "page") {
        return;
      }
      if (key === "filterValue" && value === "all") {
        params[key] = undefined;
      } else {
        params[key] = value || undefined;
      }
    });

    const result = await getCall_v2(
      `/oms/order/orderInfo?offset=0&limit=1000&businessUnit=${
        allowedBU || ""
      }`,
      params,
    );
    if (result?.data) {
      const formattedRes = result?.data?.response?.map((item) => {
        return {
          ...item,
          orderCategory: item?.category,
          orderPaymentTransactionType:
            ORDER_TRANSACTION_TYPES[item?.orderPaymentTransactionType],
          orderDate: formatOrderDate(item?.orderDate),
        };
      });
      return formattedRes;
    }
  };

  return (
    <Box>
      <OrderFilter
        disableReset={disableReset}
        setDisableReset={setDisableReset}
        refetchList={() => {
          setSearchParams(
            `filterValue=${orderFilterDuration}&filterType=${orderHeading}`,
          );
        }}
      />
      <Box py={4}>
        <OrderTable
          res={ordersData?.response}
          totalCount={ordersData?.totalCount}
          offset={ordersData?.offset}
          onPageChange={handlePageChange}
          onExportData={handleExportData}
          defaultQuickFilter={orderFilterDuration || "today"}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};
export default AllTypeOrders;
